import Cookies from 'js-cookie';
import { SESSION_KEY_PREFIX } from '../../constants';

import type { Currency } from '../../constants';
import { Cookie } from '../../model';

/**
 * Function to set the cart session key
 * Saves the session key to both cookies and closure-based storage
 */
export const setCartSessionKey = ({ name, value }: Required<Cookie>) => {
  const newSessionKey = `${name}=${value}`;
  Cookies.set(name, value, {
    expires: 30,
  });
  return newSessionKey;
};

/**
 * Function to remove the cart session key cookie(s)
 * Without this, logout leaves the WooCommerce session cookie behind and
 * CartSessionKeyProvider restores the previous user's cart session on mount
 */
export const removeCartSessionKey = () => {
  const allCookies = Cookies.get();
  Object.keys(allCookies)
    .filter((cookieName) => cookieName.includes(SESSION_KEY_PREFIX))
    .forEach((cookieName) => Cookies.remove(cookieName));
};

/**
 * Function to get the cart session key from cookies
 * Returns the cart session key cookie if found
 */
export const getCartSessionKey = () => {
  const allCookies = Cookies.get();
  const cartSessionKeyName = Object.keys(allCookies).find((cookieName) => cookieName.includes(SESSION_KEY_PREFIX));

  if (cartSessionKeyName) {
    const cartSessionKey: Cookie = {
      name: cartSessionKeyName,
      value: allCookies[cartSessionKeyName],
    };
    return { cartSessionKey };
  }

  return { cartSessionKey: undefined };
};
